import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $HomePageFileItemWrapper = styled.div<{ $isSmall?: boolean }>`
  display: flex;
  width: 100%;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  padding: 0 ${spacing(3.5)};
  gap: ${spacing(3.5)};
  height: ${({ $isSmall }) => ($isSmall ? spacing(36) : 'auto')};
  align-items: ${({ $isSmall }) => ($isSmall ? 'center' : 'stretch')};

  @media ${media.maxWidth.xs} {
    flex-direction: ${({ $isSmall }) => ($isSmall ? 'row' : 'column')};
    padding: ${spacing(3.5)};
    height: ${({ $isSmall }) => ($isSmall ? spacing(72) : 'auto')};
  }
`;

export const $LoadingWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  gap: ${spacing(3.5)};
  height: ${spacing(36)};

  @media ${media.maxWidth.xs} {
    flex-direction: row;
    padding: ${spacing(3.5)};
    height: ${spacing(72)};
  }
`;
